module.exports = __webpack_public_path__ + "static/media/about.07886a59.png";